<template>
  <div class="container">
    <div
      v-if="!ready"
      class="col"
    >
      <div class="row">
        Chargement en cours.
      </div>
    </div>
    <div
      v-if="ready"
      class="col"
    >
      <div class="row">
        <h1>Ma collection : {{ coins.length }} pièce{{ coins.length > 1 ? 's' : '' }}</h1>
      </div>
      <div class="row">
        <div class="wrapper">
          <collection-item
            v-for="coin in coins"
            :key="coin.id"
            :coin="coin"
          ></collection-item>
        </div>
      </div>
      <div
        v-if="coins.length > 0"
        class="row"
      >
        <custom-button
          class="red"
          :loading="pending"
          @click.native="clearCollection"
        >
          <i class="fas fa-trash"></i> Vider la collection
        </custom-button>
      </div>
    </div>
  </div>
</template>

<script>
  import store from './../stores';
  import FirebaseCollection from './../tools/FirebaseCollection';
  import CollectionItem from './collection-item';
  import CustomButton from './micro-components/custom-button';

  export default {
    name: 'Collection',
    components: { CustomButton, CollectionItem },
    data() {
      return {
        pending: false,
      };
    },
    computed: {
      ready() {
        return store.state.collection.hasBeenInitialized;
      },
      coins() {
        return store.state.collection.coins;
      }
    },
    created() {
      FirebaseCollection.getCoins();
    },
    methods: {
      async clearCollection() {
        this.pending = true;
        await FirebaseCollection.clearCollection();
        this.pending = false;
      },
    }
  };
</script>

<style scoped>
    h1 {
        margin: 0;
    }

    .row {
        justify-content: center;
    }

    .col {
        width: 100%;
    }

    .wrapper {
        margin: 0 5px;
        display: flex;
        flex-flow: row;
        flex-wrap: wrap;
        justify-content: space-around;
    }
</style>
